module.exports = __webpack_public_path__ + "static/media/Logo-govpl.65d43f08.svg";